const promiseAllSettled = (promises) => {
	if (Promise.allSettled) {
		return Promise.allSettled(promises);
	}

	const formattedPromises = promises.map((promise) =>
		Promise.resolve(promise)
			.then((value) => ({
				status: 'fulfilled',
				value
			}))
			.catch((reason) => ({
				status: 'rejected',
				reason
			}))
	);

	return Promise.all(formattedPromises);
};

export default promiseAllSettled;
